import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { HaccpReportsComponent } from './haccp-reports.component';

const routes: Routes = Route.withShell([
  { path: 'haccpreports', component: HaccpReportsComponent, data: { title: 'HACCP Reports' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)],
  ],
  exports:[RouterModule],
  declarations: []
})
export class HaccpReportsRoutingModule { }
